export default __webpack_public_path__ + "static/media/error404.7676b305.jpg";